export enum AppStates {
  Initial = 'initial',
  Checked = 'checked',
  SignedIn = 'signed-in',
  Unauthorized = 'unauthorized',
  Error = 'error',
}
